import { Injectable } from '@angular/core';
import {
    ResourceAction,
    ResourceCRUD,
    ResourceMethod,
    ResourceParams
} from 'ng2-resource-rest';
import { RequestMethod } from '@angular/http';

interface IUserInput {
    username : string;
    password : string;
}

export interface IUser  {
    id   : number;
    name : string;
}

@Injectable()
@ResourceParams({
    url: '/api/users',
    withCredentials: true
})
export class User extends ResourceCRUD<IUserInput, IUser, IUser> {
    @ResourceAction({
        path: '/current'
    })
    public current: ResourceMethod<void, IUser|void>;

    @ResourceAction({
        url: '/admin/login/check',
        method: RequestMethod.Post
    })
    public login: ResourceMethod<IUserInput, IUser>;

    @ResourceAction({
        url: '/admin/logout'
    })
    public logout: ResourceMethod<void, void>;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/model/user.ts